import iconRss from '../assets/icons/rss.svg';
import iconSpotify from '../assets/icons/spotify.svg';
import iconCastbox from '../assets/icons/castbox.svg';
import iconIHeartRadio from '../assets/icons/iheart_radio.svg';
import iconPlayerFm from '../assets/icons/playerfm.svg';
import iconPodchaser from '../assets/icons/podchaser.svg';
import iconStitcher from '../assets/icons/stitcher.svg';
import iconSoundcloud from '../assets/icons/soundcloud.svg';
import iconAmazonMusic from '../assets/icons/amazon_music.svg';
import iconDeezer from '../assets/icons/deezer.svg';
import iconListenNotes from '../assets/icons/listen_notes.svg';
import iconPodcastAddict from '../assets/icons/podcastaddict.svg';
import iconRadioPublic from '../assets/icons/radiopublic.svg';
import iconMixcloud from '../assets/icons/mixcloud.svg';
import iconTuneIn from '../assets/icons/tunein.svg';
import iconPocketCasts from '../assets/icons/pocketcasts.svg';
import iconOvercast from '../assets/icons/overcast.svg';
import iconApplePodcasts from '../assets/icons/apple_podcasts.svg';
import iconGooglePodcasts from '../assets/icons/google_podcasts.svg';

// list of supported subscriber services, the order of keys matter as the top-most providers are given priority when sorting the list
const _supportedSyndicators = {
  rss: {
    icon: iconRss,
    label: 'RSS'
  },
  apple: {
    icon: iconApplePodcasts,
    label: 'Apple Podcasts'
  },
  google: {
    icon: iconGooglePodcasts,
    label: 'Google Podcasts'
  },
  spotify: {
    icon: iconSpotify,
    label: 'Spotify'
  },
  castbox: {
    icon: iconCastbox,
    label: 'CastBox'
  },
  iheart: {
    icon: iconIHeartRadio,
    label: 'iHeart'
  },
  playerfm: {
    icon: iconPlayerFm,
    label: 'Player FM'
  },
  podchaser: {
    icon: iconPodchaser,
    label: 'Podchaser'
  },
  stitcher: {
    icon: iconStitcher,
    label: 'Stitcher'
  },
  soundcloud: {
    icon: iconSoundcloud,
    label: 'Soundcloud'
  },
  amazon: {
    icon: iconAmazonMusic,
    label: 'Amazon Music'
  },
  deezer: {
    icon: iconDeezer,
    label: 'Deezer'
  },
  listennotes: {
    icon: iconListenNotes,
    label: 'Listen Notes'
  },
  podcastaddict: {
    icon: iconPodcastAddict,
    label: 'Podcast Addict'
  },
  radiopublic: {
    icon: iconRadioPublic,
    label: 'RadioPublic'
  },
  mixcloud: {
    icon: iconMixcloud,
    label: 'Mixcloud'
  },
  tunein: {
    icon: iconTuneIn,
    label: 'TuneIn'
  },
  pocketcasts: {
    icon: iconPocketCasts,
    label: 'Pocket Casts'
  },
  overcast: {
    icon: iconOvercast,
    label: 'Overcast'
  }
};
// maps service type to its index in the providers list
const _syndicatorOrder = {};
Object.keys(_supportedSyndicators).forEach(function (service, index) {
  _syndicatorOrder[service] = index;
});

/**
 * Retrieve a list of syndication providers from a playlist object
 *
 * @param  {object} playlist A playlist object
 * @return {array}
 */
export function supportedSyndicators (links) {
  const supported = [];
  links.forEach(function (link) {
    if (_supportedSyndicators[link.kind]) {
      supported.push({
        service: link.kind,
        url: link.url,
        icon: _supportedSyndicators[link.kind].icon,
        label: link.title || _supportedSyndicators[link.kind].label
      });
    }
  });
  supported.sort(syndicatorSorter);
  return supported;
}

/**
 * Sorts the provider list
 *
 * Sorted by their position in the provider list above
 *
 * @param  {object} a A provider item
 * @param  {object} b Another provider item
 * @return {int}
 */
function syndicatorSorter (a, b) {
  const hasOrderA = typeof _syndicatorOrder[a.service] !== 'undefined';
  const hasOrderB = typeof _syndicatorOrder[b.service] !== 'undefined';

  if (hasOrderA && hasOrderB) {
    return _syndicatorOrder[a.service] - _syndicatorOrder[b.service];
  }
  if (hasOrderA) {
    return 1;
  }
  if (hasOrderB) {
    return -1;
  }

  return a.label.localeCompare(b.label);
}

/**
 * Renders the provider icon
 *
 * @todo move syndication provider icon rendering to ui only util
 * @param  {object} provider A syndication provider object
 * @return {string}
 */
export function renderSyndicatorIcon (syndicator) {
  if (syndicator.icon.substr(0, 4) === '<svg') {
    return `<span class="iono-icon iono-subscribe-provider-icon">${syndicator.icon}</span>`;
  }
  return `<img src="${syndicator.icon}" class="iono-icon iono-subscribe-provider-icon" />`;
}

export default {
  renderSyndicatorIcon: renderSyndicatorIcon,
  supportedSyndicators: supportedSyndicators
};
